import logger from "../../lib/appfuse-react/core/logger";
import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";


const LOGGER = logger.getLogger('processingMarkDeclareReducer');

const name = 'processingMarkDeclare';

const initialState = {
    data: [],
    selection: [],
    pageNumber: 0,
    pageSize: 5,
    criteria: {},
    sort: null,
    returnSelection: [],
    returnPageNumber: 0,
    returnPageSize: 5,
    returnCriteria: {},
    returnSort: null,
    drafts: {},
    returnDrafts: {},
    nodeId: null,
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setSelection(state, action) {
            state.selection = json.toJSON(action.payload);
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setCriteria(state, action) {
            state.criteria = json.toJSON(action.payload);
        },
        setSort(state, action) {
            state.sort = json.toJSON(action.payload);
        },
        setReturnSelection(state, action) {
            state.returnSelection = json.toJSON(action.payload);
        },
        setReturnPageNumber(state, action) {
            state.returnPageNumber = action.payload;
        },
        setReturnPageSize(state, action) {
            state.returnPageSize = action.payload;
        },
        setReturnCriteria(state, action) {
            state.returnCriteria = json.toJSON(action.payload);
        },
        setReturnSort(state, action) {
            state.returnSort = json.toJSON(action.payload);
        },
        setDrafts(state, action) {
            state.drafts = json.toJSON(action.payload);
        },
        setReturnDrafts(state, action) {
            state.returnDafts = json.toJSON(action.payload);
        },
        setNodeId(state, action) {
            state.nodeId = action.payload;
        },
    }
});

export const {setData, setSelection, setPageNumber, setPageSize, setCriteria, setDrafts, setSort, setReturnDrafts, setReturnCriteria, setReturnSort, setReturnSelection, setReturnPageNumber, setReturnPageSize} = slice.actions;
const {reducer} = slice;

export const selectData = state => json.fromJSON(state[name].data);
export const selectCriteria = state => state[name].criteria;
export const selectSort = state => json.fromJSON(state[name].sort);
export const selectSelection = state => json.fromJSON(state[name].selection);
export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectDrafts = state => json.fromJSON(state[name].drafts);
export const selectReturnCriteria = state => state[name].returnCriteria;
export const selectReturnSort = state => json.fromJSON(state[name].returnSort);
export const selectReturnSelection = state => json.fromJSON(state[name].returnSelection);
export const selectReturnPageNumber = state => state[name].returnPageNumber;
export const selectReturnPageSize = state => state[name].returnPageSize;
export const selectReturnDrafts = state => json.fromJSON(state[name].returnDrafts);
export const selectDraft = (key) => (state) => selectDrafts(state)[key];
export const selectReturnDraft = (key) => (state) => selectReturnDrafts(state)[key];
export const selectActiveStep = state => state[name].activeStep;


export const setDraft = (key, draft) => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    drafts[key] = draft;
    dispatch(setDrafts(drafts));
}

export const setReturnDraft = (key, draft) => (dispatch, getState) => {
    const drafts = selectReturnDrafts(getState());
    drafts[key] = draft;
    dispatch(setReturnDrafts(drafts));
}

export const removeDraft = key => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    delete drafts[key];
    dispatch(setDrafts(drafts));
}

export const removeReturnDraft = key => (dispatch, getState) => {
    const drafts = selectReturnDrafts(getState());
    delete drafts[key];
    dispatch(setReturnDrafts(drafts));
}

const processingMarkDeclareReducer = reducer;
export default processingMarkDeclareReducer;